<app-header></app-header>
<div class="comman-container">
  <router-outlet></router-outlet> <!-- Dynamically Load Pages -->
</div>